export default "__VITE_ASSET__36c86015__"